import React from "react";
import { twMerge } from "tailwind-merge";

interface InlineEditorSkeletonProps {
  skeletonClassName?: string;
}

export const InlineEditorSkeleton: React.FC<InlineEditorSkeletonProps> = ({
  skeletonClassName = "bg-bg-pressed/40",
}) => {
  return (
    <div className="mx-auto max-w-4xl py-8">
      <div className="flex min-w-0 flex-1 flex-col rounded-2xl border border-limestone-100 bg-white">
        <div className="flex flex-col gap-2 border-b border-limestone-100 px-8 py-12 animate-pulse">
          <div className="flex items-center gap-4">
            <div className={twMerge("h-8 w-1/2 rounded-sm", skeletonClassName)} />
            <div className={twMerge("h-8 w-24 rounded-sm", skeletonClassName)} />
            <div className={twMerge("h-8 w-full")} />
            <div className={twMerge("h-6 w-48 rounded-sm", skeletonClassName)} />
            <div className={twMerge("h-6 w-48 rounded-sm", skeletonClassName)} />
          </div>

          <div className="space-y-4 mt-4">
            {["h-12", "h-20", "h-12"].map((h, i) => (
              <div key={i} className="space-y-2">
                <div className={twMerge("h-4 w-32 rounded-sm", skeletonClassName)} />
                <div className={twMerge(h, "w-full rounded-sm", skeletonClassName)} />
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4 px-8 py-6 animate-pulse">
          <div className={twMerge("h-5 w-48 rounded-sm", skeletonClassName)} />

          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className={twMerge("h-4 w-40 rounded-sm", skeletonClassName)} />
              <div className="flex gap-2">
                <div className={twMerge("h-8 w-8 rounded-sm", skeletonClassName)} />
                <div className={twMerge("h-8 w-8 rounded-sm", skeletonClassName)} />
              </div>
            </div>
            <div className={twMerge("h-32 w-full rounded-sm", skeletonClassName)} />
          </div>
        </div>

        <div className="flex flex-col items-start pt-8 px-8 pb-8 animate-pulse">
          <div className={twMerge("h-6 w-32 rounded-sm mb-4", skeletonClassName)} />
          <div className={twMerge("h-64 w-full rounded-sm", skeletonClassName)} />
        </div>
      </div>
    </div>
  );
};
